import { PokerAppInitService } from './poker-app-init.service';
import { runOnPokerAppInit } from './run-on-poker-app.provider';

export const providePokerAppBootstrap = () => runOnPokerAppInit(PokerAppInitService);
